import React from "react";
import { Spin } from "antd";
import { useTranslation } from "react-i18next";
import AppButton from "components/ui/AppButton";
import AppOutlineButton from "components/ui/AppOutlineButton";
const RefundNotRequiredConfirmation = ({
  closeModal,
  onSubmit,
  loading,
  order,
}) => {
  const { t } = useTranslation();
  return (
    <Spin spinning={loading}>
      <div className="relative mx-auto my-auto w-full bg-white p-2">
        <div className="my-2">
          <div className="rounded-xl border border-gray-200 p-4 text-sm text-gray-700">
            {t("Order")} #{order?.orderNumber}
          </div>
          <div className="px-1 py-4 text-sm text-gray-700">
            {t("Are you sure you want to mark Order as nonrefundable", {
              orderNumber: order?.orderNumber,
            })}
          </div>
          <div className="mt-2 flex justify-end gap-2">
            <AppOutlineButton disabled={loading} onClick={closeModal}>
              {t("No")}
            </AppOutlineButton>
            <AppButton variant="danger" disabled={loading} onClick={onSubmit}>
              {t("Yes")}
            </AppButton>
          </div>
        </div>
      </div>
    </Spin>
  );
};
export default RefundNotRequiredConfirmation;
